export default {
  eyebrow: 'Partnerportaal',
  title: 'Facturering',
  description: 'Uw betaalmethode voor de maandelijkse platformfactuur en elke factuur met de volledige specificatie.',
  toasts: {
    checkout_error: 'Afrekenen kon niet worden gestart — probeer het opnieuw.',
    action_error: 'De actie is mislukt — probeer het opnieuw.',
    onboarding_error: 'Kan de verificatie niet starten — probeer het opnieuw.',
    payment_method_in_use:
      'Je restaurantlicenties worden via deze betaalmethode gefactureerd, dus deze kan niet worden verwijderd. Vervang hem in plaats daarvan door een nieuwe.',
  },
  payout_bank_account: {
    title: 'Bankrekening voor uitbetalingen',
    description:
      'Uitbetalingen van de omzetdeling komen binnen in {{currency}}. Stripe rekent de overboeking om wanneer deze binnenkomt.',
    toasts: {
      saved: 'Bankrekening opgeslagen',
      save_failed: 'We konden de bankrekening niet opslaan. Controleer de gegevens.',
    },
  },
  payout_onboarding: {
    title: 'Stel je uitbetalingsaccount in',
    description:
      'Je omzetaandeel wordt maandelijks uitbetaald op een Stripe-uitbetalingsaccount. Voltooi de verificatie eenmalig — uitbetalingen blijven in de wacht staan totdat dit is gedaan.',
    missing: {
      title: 'Nog nodig voordat uitbetalingen kunnen starten:',
      bank_account: 'Voeg de bankrekening toe waarop je omzetdeel moet worden uitbetaald.',
      business_details: 'Vul je bedrijfsgegevens aan, zoals adres, btw-nummer of KvK-nummer.',
      people: 'Voeg de gegevens toe van je bedrijfsvertegenwoordiger, eigenaren of directeuren.',
      documents: 'Upload de verificatiedocumenten die Stripe heeft gevraagd.',
      terms: 'Accepteer de servicevoorwaarden van Stripe.',
      other: 'Verstrek de overige gegevens die Stripe heeft gevraagd.',
    },
    start: 'Verificatie starten',
    continue: 'Verificatie voortzetten',
    ready:
      'Uitbetalingsaccount geverifieerd — je omzetaandeel wordt na elke factureringscyclus automatisch uitbetaald.',
  },
  payment_method: {
    title: 'Betaalmethode',
    empty: 'Geen betaalmethode opgeslagen — de maandelijkse factuur kan nog niet automatisch worden geïnd.',
    add: 'Betaalmethode toevoegen',
    replace: 'Vervangen',
    remove: 'Verwijderen',
    remove_confirm: {
      title: 'Deze betaalmethode verwijderen?',
      description:
        'De kaart/het mandaat wordt direct losgekoppeld van Stripe. Zonder betaalmethode worden facturen — inclusief reeds uitgegeven — geïnd via de gehoste Stripe-factuur in plaats van automatisch.',
      confirm: 'Verwijderen',
    },
  },
  invoices: {
    title: 'Facturen',
  },
};
